import { PUBLIC_PTC_FULL_VERSION } from "./env";
export const fullVersion = PUBLIC_PTC_FULL_VERSION;
export const version = fullVersion.split(".").slice(0, 3).join(".");
export function compareVersions(v1, v2) {
    const [major1, minor1, patch1] = v1.split(".");
    const [major2, minor2, patch2] = v2.split(".");
    return Number(major1) - Number(major2) || Number(minor1) - Number(minor2) || Number(patch1) - Number(patch2);
}
//# sourceMappingURL=version.js.map